module.exports = __webpack_public_path__ + "img/logo_login.c9f6e461.jpg";